(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["order-bump"] && !Shopify.designMode) return;
  try {
    var OrderBump = {
    allProducts: [],
    
    init: function() {
      this.loadProducts();
      this.initButtons();
      this.initDragScroll();
      this.listenCartUpdates();
    },
    
    initDragScroll: function() {
      var containers = document.querySelectorAll('[data-order-bump-products-list]');
      
      containers.forEach(function(container) {
        if (container.dataset.dragInitialized) return;
        container.dataset.dragInitialized = 'true';
        
        var isDown = false;
        var startX;
        var scrollLeft;
        
        container.addEventListener('mousedown', function(e) {
          if (e.target.closest('a') || e.target.closest('button')) return;
          isDown = true;
          container.classList.add('is-dragging');
          startX = e.pageX - container.offsetLeft;
          scrollLeft = container.scrollLeft;
        });
        
        container.addEventListener('mouseleave', function() {
          isDown = false;
          container.classList.remove('is-dragging');
        });
        
        container.addEventListener('mouseup', function() {
          isDown = false;
          container.classList.remove('is-dragging');
        });
        
        container.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          e.preventDefault();
          var x = e.pageX - container.offsetLeft;
          var walk = (x - startX) * 1.5;
          container.scrollLeft = scrollLeft - walk;
        });
        
        container.addEventListener('touchstart', function(e) {
          if (e.target.closest('a') || e.target.closest('button')) return;
          startX = e.touches[0].pageX - container.offsetLeft;
          scrollLeft = container.scrollLeft;
        }, { passive: true });
        
        container.addEventListener('touchmove', function(e) {
          if (!startX) return;
          var x = e.touches[0].pageX - container.offsetLeft;
          var walk = (x - startX) * 1.5;
          container.scrollLeft = scrollLeft - walk;
        }, { passive: true });
        
        container.addEventListener('touchend', function() {
          startX = null;
        });
      });
    },
    
    loadProducts: function() {
      var script = document.querySelector('[data-order-bump-products]');
      if (script) {
        try {
          this.allProducts = JSON.parse(script.textContent);
        } catch (e) {
          console.error('Error loading order bump products:', e);
        }
      }
    },
    
    getCartProductIds: function() {
      var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      return fetch(rootUrl + 'cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          return cart.items.map(function(item) { return item.product_id; });
        });
    },
    
    renderProducts: function(cartProductIds) {
      var self = this;
      var container = document.querySelector('[data-order-bump-products-list]');
      var orderBumpContainer = document.querySelector('[data-order-bump-container]');
      
      if (!container || !orderBumpContainer) return;
      
      var availableProducts = this.allProducts.filter(function(product) {
        return cartProductIds.indexOf(product.id) === -1;
      });
      
      if (availableProducts.length === 0) {
        orderBumpContainer.style.display = 'none';
        return;
      }
      
      orderBumpContainer.style.display = '';
      container.innerHTML = '';
      
      availableProducts.forEach(function(product) {
        var productEl = document.createElement('div');
        productEl.className = 'order-bump__product';
        productEl.dataset.productId = product.id;
        
        var imageHtml = product.image 
          ? '<img src="' + product.image + '" loading="lazy" alt="' + self.escapeHtml(product.title) + '">'
          : '';
        
        productEl.innerHTML = 
          '<a href="' + product.url + '" class="order-bump__product-image-link">' +
            '<div class="order-bump__product-image">' + imageHtml + '</div>' +
          '</a>' +
          '<div class="order-bump__product-info">' +
            '<div class="order-bump__product-title-wrapper">' +
              '<span class="order-bump__product-title">' + self.escapeHtml(product.title) + '</span>' +
              '<button type="button" class="order-bump__product-button" data-product-handle="' + product.handle + '" data-product-id="' + product.id + '">' +
                'LEVAR JUNTO!' +
              '</button>' +
            '</div>' +
            '<span class="order-bump__product-price">' + product.price + '</span>' +
          '</div>';
        
        container.appendChild(productEl);
      });
      
      this.initButtons();
      this.initDragScroll();
    },
    
    escapeHtml: function(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },
    
    hideProduct: function(productId) {
      var productEl = document.querySelector('[data-order-bump-products-list] [data-product-id="' + productId + '"]');
      if (productEl) {
        productEl.style.transition = 'opacity 0.3s, transform 0.3s';
        productEl.style.opacity = '0';
        productEl.style.transform = 'scale(0.8)';
        setTimeout(function() {
          productEl.remove();
          
          var container = document.querySelector('[data-order-bump-products-list]');
          var orderBumpContainer = document.querySelector('[data-order-bump-container]');
          if (container && container.children.length === 0 && orderBumpContainer) {
            orderBumpContainer.style.display = 'none';
          }
        }, 300);
      }
    },
    
    initButtons: function() {
      var self = this;
      var buttons = document.querySelectorAll('.order-bump__product-button');
      
      buttons.forEach(function(button) {
        if (button.dataset.initialized) return;
        button.dataset.initialized = 'true';
        
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.handleAddToCart(this);
        });
      });
    },
    
    handleAddToCart: function(button) {
      var self = this;
      var productHandle = button.dataset.productHandle;
      var productId = parseInt(button.dataset.productId, 10);
      
      if (!productHandle || button.disabled) return;
      
      var originalHTML = button.innerHTML;
      button.disabled = true;
      button.classList.add('order-bump__product-button--loading');
      button.innerHTML = '<span class="spinner"></span>';
      
      var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      
      var cartItemsComponent = document.querySelector('cart-items-component');
      var sectionId = cartItemsComponent && cartItemsComponent.dataset ? cartItemsComponent.dataset.sectionId : '';
      var sectionsToRender = sectionId ? sectionId + ',cart-icon-bubble' : 'cart-icon-bubble';
      
      fetch('/products/' + productHandle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(product) {
          if (!product || !product.variants || product.variants.length === 0) {
            throw new Error('Product not found');
          }
          
          var variantId = product.variants[0].id;
          
          return fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sectionsToRender,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function(response) { return response.json(); })
        .then(function(addData) {
          return fetch(rootUrl + 'cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
              if (addData.sections && sectionId && addData.sections[sectionId]) {
                var parser = new DOMParser();
                var newDoc = parser.parseFromString(addData.sections[sectionId], 'text/html');
                var newCartItems = newDoc.querySelector('cart-items-component');
                
                if (cartItemsComponent && newCartItems) {
                  cartItemsComponent.innerHTML = newCartItems.innerHTML;
                }
              }
              
              self.updateCartBubble(cart);
              self.dispatchCartEvent(cart, addData.sections);
              
              button.classList.remove('order-bump__product-button--loading');
              button.classList.add('order-bump__product-button--success');
              button.innerHTML = '<svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
              
              setTimeout(function() {
                self.hideProduct(productId);
              }, 800);
            });
        })
        .catch(function(error) {
          console.error('Error adding product to cart:', error);
          button.disabled = false;
          button.classList.remove('order-bump__product-button--loading');
          button.innerHTML = originalHTML;
        });
    },
    
    updateCartBubble: function(cart) {
      var cartBubbles = document.querySelectorAll('.cart-bubble__text, [ref="cartItemCount"]');
      cartBubbles.forEach(function(bubble) {
        if (bubble.textContent !== undefined) {
          bubble.textContent = cart.item_count;
        }
      });
      
      var cartBubbleContainers = document.querySelectorAll('.cart-bubble');
      cartBubbleContainers.forEach(function(container) {
        var textEl = container.querySelector('.cart-bubble__text');
        if (textEl) textEl.textContent = cart.item_count;
      });
    },
    
    dispatchCartEvent: function(cart, sections) {
      var customEvent = new CustomEvent('theme:cart:update', {
        detail: {
          cart: cart,
          itemCount: cart.item_count,
          sections: sections || {}
        }
      });
      document.dispatchEvent(customEvent);
    },
    
    listenCartUpdates: function() {
      var self = this;
      
      document.addEventListener('theme:cart:update', function(e) {
        if (e.detail && e.detail.cart) {
          var cartProductIds = e.detail.cart.items.map(function(item) { return item.product_id; });
          self.renderProducts(cartProductIds);
        }
      });
      
      document.addEventListener('cart:refresh', function() {
        self.getCartProductIds().then(function(cartProductIds) {
          self.renderProducts(cartProductIds);
        });
      });
      
      var originalFetch = window.fetch;
      window.fetch = function(url, options) {
        return originalFetch.apply(this, arguments).then(function(response) {
          var urlStr = typeof url === 'string' ? url : url.url;
          if (urlStr && (urlStr.includes('/cart/change') || urlStr.includes('/cart/update') || urlStr.includes('/cart/clear'))) {
            setTimeout(function() {
              self.getCartProductIds().then(function(cartProductIds) {
                self.renderProducts(cartProductIds);
              });
            }, 100);
          }
          return response;
        });
      };
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { OrderBump.init(); });
  } else {
    OrderBump.init();
  }
  } catch(e) { console.error(e); }
})();

})();
